import IconPicker from '../../../scripts/iconpicker-1.5.0.js';

angular.module("events_programs_mails")

    .controller("EventsProgramsMailsEditCtrl", ['LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal',
        function (LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("DEFAULT_PROGRAMS_MAILS_WRITE");

            $scope.data = {
                program_mail_list_array: []
            }

            $rootScope.title = $filter('translate')('events_programs_mails.title');

            $rootScope.breadcrumb = [
                { title: $filter('translate')('events_programs_mails.title') },
            ];

            Restangular.all('Events').customGET("GetDefaultProgramMailList").then(function (result) {

                if (result != null && result != "") {
                    $scope.data.program_mail_list_array = result.split(',');
                } else {
                    $scope.data.program_mail_list_array = [];
                }

            })

            $scope.saveMailList = function () {
                let invalidMails = [];

                // Validamos la lista de emails
                if ($scope.data.program_mail_list_array.length > 0) {

                    // Limpiamos el array = 
                    $scope.data.program_mail_list_array = $scope.data.program_mail_list_array.map(m => m.trim());
                    invalidMails = $scope.data.program_mail_list_array.filter(m => !validateEmail(m));

                    if (invalidMails.length > 0) {

                        let titleString = $filter('translate')('general.error');
                        let messageString = $filter('translate')('general.invalid_emails_message') + ": " + invalidMails.join(', ');

                        return modalService.message({
                            title: titleString,
                            message: messageString,
                            onAccept: function () { }
                        });

                    }
                }

                // Guardamos el evento
                if ($scope.data.program_mail_list_array.length > 0) {

                    $scope.data.program_mail_list = $scope.data.program_mail_list_array.join(', ');

                } else {

                    $scope.data.program_mail_list = null;
                    $scope.data.program_mail_list_array = [];

                };

                Restangular.all('Events/SetDefaultProgramMailList').customPUT({ value: $scope.data.program_mail_list })
                    .then(function (response) {
                        console.log("Actualización exitosa:", response);
                    })
                    .catch(function (error) {
                        console.error("Error al actualizar la lista de correos", error);
                    });
            }

            let validateEmail = function (valor) {
                let emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (emailPattern.test(valor)) {
                    return true;
                } else {
                    return false;
                }
            };

        }])

    ;

